<template>
  <div class="sub-view">
    <h3>Pengajuan cuti <span style="color: #eb5757">*</span></h3>

    <div class="list-form">
      <!-- tanggal mulai -->
      <label
        ref="tanggal-mulai-form"
        tabindex="0"
        for="date-picker-mulai"
        class="box-form email"
      >
        <svg
          width="14"
          height="16"
          viewBox="0 0 14 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M9.85725 0.857422V3.71456M4.14296 0.857422V3.71456M0.571533 6.57171H13.4287M2.0001 2.28599H12.0001C12.7891 2.28599 13.4287 2.92559 13.4287 3.71456V13.7146C13.4287 14.5035 12.7891 15.1431 12.0001 15.1431H2.0001C1.21113 15.1431 0.571533 14.5035 0.571533 13.7146V3.71456C0.571533 2.92559 1.21113 2.28599 2.0001 2.28599Z"
            stroke="#A0A3BD"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>

        <div class="input-and-title">
          <span style="display: none" class="input-title">Tanggal mulai</span>
          <input
            @change="inputChanged($event)"
            id="date-picker-akhir"
            class="date-control"
            type="date"
            v-model="pengajuanCuti.tanggalMulai"
            :min="minDateMulai"
          />
          <p>
            {{
              pengajuanCuti.tanggalMulai
                ? pengajuanCuti.tanggalMulai
                : "Tanggal mulai"
            }}
          </p>
        </div>
      </label>
      <!-- end tanggal mulai-->

      <!-- tanggal akhir -->
      <label
        ref="tanggal-akhir-form"
        tabindex="0"
        for="date-picker-akhir"
        class="box-form email"
      >
        <svg
          width="14"
          height="16"
          viewBox="0 0 14 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M9.85725 0.857422V3.71456M4.14296 0.857422V3.71456M0.571533 6.57171H13.4287M2.0001 2.28599H12.0001C12.7891 2.28599 13.4287 2.92559 13.4287 3.71456V13.7146C13.4287 14.5035 12.7891 15.1431 12.0001 15.1431H2.0001C1.21113 15.1431 0.571533 14.5035 0.571533 13.7146V3.71456C0.571533 2.92559 1.21113 2.28599 2.0001 2.28599Z"
            stroke="#A0A3BD"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>

        <div class="input-and-title">
          <span style="display: none" class="input-title">Tanggal akhir</span>
          <input
            @change="inputChangedAkhir($event)"
            id="date-picker-akhir"
            class="date-control"
            type="date"
            v-model="pengajuanCuti.tanggalAkhir"
            :min="minDateAkhir"
          />
          <p>
            {{
              pengajuanCuti.tanggalAkhir
                ? pengajuanCuti.tanggalAkhir
                : "Tanggal akhir"
            }}
          </p>
        </div>
      </label>
      <!-- end tanggal akhir -->

      <!-- lampiran dokumen -->
      <div class="input-lampiran">
        <label ref="lampiran-form" class="box-form email">
          <svg
            width="14"
            height="14"
            viewBox="0 0 14 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M13.4284 9.14369V12.0008C13.4284 12.3797 13.2779 12.7431 13.01 13.011C12.7421 13.2789 12.3787 13.4294 11.9999 13.4294H1.99986C1.62098 13.4294 1.25762 13.2789 0.989708 13.011C0.721799 12.7431 0.571289 12.3797 0.571289 12.0008V9.14369M10.5713 4.14369L6.99986 0.572266M6.99986 0.572266L3.42843 4.14369M6.99986 0.572266V9.14369"
              stroke="#A0A3BD"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>

          <div class="input-and-title">
            <span style="display: none" class="input-title">Lampiran</span>
            <input ref="lampiran-input"
              @change="processFile($event)"
              class="input-text"
              type="file"
              accept="image/*,.pdf"
            />
            <p>
              {{
                pengajuanCuti.lampiran
                  ? pengajuanCuti.lampiran.name
                  : "Lampiran.pdf"
              }}
            </p>
          </div>
        </label>
        <p
          class="penjelasan-lampiran"
          style="margin-top: -44px; color: #a0a3bd"
        >
          Format .pdf, .jpg, .jpeg, .png (max: 3.5 MB)
        </p>
      </div>

      <!-- end of lampiran dokumen -->

      <!-- keterangan -->
      <div class="keterangan input-keterangan">
        <div
          ref="keterangan-form"
          @click="openClosePilihan(true)"
          class="box-form email"
        >
          <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <mask id="path-1-inside-1" fill="white">
              <path
                d="M7.99979 15.1431C11.9447 15.1431 15.1426 11.9452 15.1426 8.00028C15.1426 4.05539 11.9447 0.857422 7.99979 0.857422C4.0549 0.857422 0.856934 4.05539 0.856934 8.00028C0.856934 11.9452 4.0549 15.1431 7.99979 15.1431Z"
              />
              <path
                d="M8.71408 5.14314C8.71408 5.53762 8.39428 5.85742 7.99979 5.85742C7.6053 5.85742 7.2855 5.53762 7.2855 5.14314C7.2855 4.74865 7.6053 4.42885 7.99979 4.42885C8.39428 4.42885 8.71408 4.74865 8.71408 5.14314Z"
              />
            </mask>
            <path
              d="M7.49979 10.8574C7.49979 11.1336 7.72365 11.3574 7.99979 11.3574C8.27593 11.3574 8.49979 11.1336 8.49979 10.8574H7.49979ZM8.49979 8.00028C8.49979 7.72414 8.27593 7.50028 7.99979 7.50028C7.72365 7.50028 7.49979 7.72414 7.49979 8.00028H8.49979ZM8.49979 10.8574V8.00028H7.49979V10.8574H8.49979ZM14.1426 8.00028C14.1426 11.3929 11.3924 14.1431 7.99979 14.1431V16.1431C12.497 16.1431 16.1426 12.4975 16.1426 8.00028H14.1426ZM7.99979 14.1431C4.60718 14.1431 1.85693 11.3929 1.85693 8.00028H-0.143066C-0.143066 12.4975 3.50261 16.1431 7.99979 16.1431V14.1431ZM1.85693 8.00028C1.85693 4.60767 4.60718 1.85742 7.99979 1.85742V-0.142578C3.50261 -0.142578 -0.143066 3.5031 -0.143066 8.00028H1.85693ZM7.99979 1.85742C11.3924 1.85742 14.1426 4.60767 14.1426 8.00028H16.1426C16.1426 3.5031 12.497 -0.142578 7.99979 -0.142578V1.85742ZM7.71408 5.14314C7.71408 4.98534 7.84199 4.85742 7.99979 4.85742V6.85742C8.94656 6.85742 9.71408 6.08991 9.71408 5.14314H7.71408ZM7.99979 4.85742C8.15759 4.85742 8.2855 4.98534 8.2855 5.14314H6.2855C6.2855 6.08991 7.05302 6.85742 7.99979 6.85742V4.85742ZM8.2855 5.14314C8.2855 5.30093 8.15759 5.42885 7.99979 5.42885V3.42885C7.05302 3.42885 6.2855 4.19636 6.2855 5.14314H8.2855ZM7.99979 5.42885C7.84199 5.42885 7.71408 5.30093 7.71408 5.14314H9.71408C9.71408 4.19636 8.94656 3.42885 7.99979 3.42885V5.42885Z"
              fill="#A0A3BD"
              mask="url(#path-1-inside-1)"
            />
          </svg>

          <div class="input-and-title">
            <span
              v-if="pengajuanCuti.keterangan"
              style="display: block"
              class="input-title"
              >Keterangan</span
            >
            <p>
              {{
                pengajuanCuti.keterangan
                  ? pengajuanCuti.keterangan
                  : "Keterangan"
              }}
            </p>
          </div>
        </div>
        <!-- box pilihan keterangan -->
        <div
          style="display: none; max-height: 142px"
          ref="boxPilihan"
          class="box-pilihan"
        >
          <p
            :key="keterangan"
            v-for="keterangan in listKeteranganCuti"
            @click="openClosePilihan(false, keterangan)"
          >
            {{ keterangan }}
            <svg
              v-if="keterangan === pengajuanCuti.keterangan"
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M15.7142 5.71484L7.85707 13.572L4.28564 10.0006"
                stroke="#00BA88"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </p>
        </div>
        <!-- end of box pilihan keterangan -->
      </div>
      <!-- end of keterangan -->
    </div>

    <!-- button dan catatan -->
   <div class="button-and-catatan">
      <button
        :disabled="isProcessing"
        @click="ajukanCuti"
        class="yellow-button"
      >
        <div ref="spinner" style="display: none" class="spinner">
          <div class="bounce1"></div>
          <div class="bounce2"></div>
          <div class="bounce3"></div>
        </div>
        <span ref="button-text"> Ajukan</span>
      </button>
      <p>*Pastikan semua kolom sudah terisi</p>
    </div>
    <!--end of button dan catatan -->

    <!-- modal berhasil -->
    <ModalBerhasil v-if="modalBerhasilIsOpen">
      <!-- icon modal -->
      <template v-slot:icon>
        <svg
          width="89"
          height="88"
          viewBox="0 0 89 88"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="44.5" cy="44" r="44" fill="#00BA88" />
          <path
            d="M65.4526 42.0845V44.0121C65.45 48.5303 63.987 52.9267 61.2817 56.5454C58.5764 60.1642 54.7738 62.8116 50.441 64.0927C46.1082 65.3737 41.4773 65.2199 37.2391 63.6541C33.0009 62.0883 29.3824 59.1944 26.9232 55.4041C24.464 51.6137 23.296 47.13 23.5933 42.6215C23.8906 38.1131 25.6372 33.8215 28.5728 30.3869C31.5084 26.9523 35.4756 24.5586 39.8827 23.5629C44.2899 22.5672 48.9008 23.0227 53.0279 24.8616M65.4526 27.2502L44.5002 48.2236L38.2145 41.9378"
            stroke="#FCFCFC"
            stroke-width="3"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </template>
      <!-- text modal -->
      <template v-slot:text>
        <h2>Sukses Tambah Data</h2>
      </template>
      <!-- close button -->
      <template v-slot:close>
        <svg
          @click="goToRiwayat"
          class="close-button"
          width="32"
          height="32"
          viewBox="0 0 32 32"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M22.8574 9.14307L9.14307 22.8574M9.14307 9.14307L22.8574 22.8574"
            stroke="#1D1D1D"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </template>
    </ModalBerhasil>
    <!-- end of modal berhasil -->

    <!-- modal gagal -->
    <ModalGagal v-if="modalGagalIsOpen">
      <!-- icon modal -->
      <template v-slot:icon>
        <svg
          width="88"
          height="88"
          viewBox="0 0 88 88"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M42.2679 11.8001C43.0377 10.4667 44.9622 10.4667 45.7321 11.8L80.3731 71.8C81.1429 73.1334 80.1806 74.8 78.641 74.8H9.35899C7.81939 74.8 6.85713 73.1334 7.62693 71.8L42.2679 11.8001Z"
            fill="#EB5757"
          />
          <path
            d="M46.4196 35.2L45.6276 57.1999H40.3916L39.5996 35.2H46.4196ZM46.3756 61.0719V67.54H39.6876V61.0719H46.3756Z"
            fill="#FCFCFC"
          />
        </svg>
      </template>
      <!-- text modal -->
      <template v-slot:text>
        <h2>
          Terdapat data yang belum sesuai, <br />
          dengan ketentuan
        </h2>
      </template>
      <!-- close button -->
      <template v-slot:close>
        <svg
          @click="openCloseModalGagal(false)"
          class="close-button"
          width="32"
          height="32"
          viewBox="0 0 32 32"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M22.8574 9.14307L9.14307 22.8574M9.14307 9.14307L22.8574 22.8574"
            stroke="#1D1D1D"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </template>
    </ModalGagal>
    <!-- end of modal gagal -->
  </div>
</template>

<script>
import ModalBerhasil from "@/components/modal/ModalAlert";
import ModalGagal from "@/components/modal/ModalAlert";
import { mapState } from "vuex";
import * as soluhaApi from "@/soluhaApi";

export default {
  components: {
    ModalBerhasil,
    ModalGagal,
  },

  data() {
    return {
      isProcessing: false,
      // status modal
      modalBerhasilIsOpen: false,
      modalGagalIsOpen: false,
      //value pengajuan cuti
      pengajuanCuti: {
        tanggalMulai: null,
        tanggalAkhir: null,
        keterangan: null,
        lampiran: null,
      },
    };
  },

  methods: {
    // untuk tutup atau buku box pilihan
    openClosePilihan(open, value) {
      let box = this.$refs.boxPilihan;
      if (open) {
        box.style.display = "block";
      } else {
        box.style.display = "none";
        this.pengajuanCuti.keterangan = value;
      }
    },
    // buka atau tutup modal berhasil
    openCloseModalBerhasil(isOpen) {
      if (isOpen) {
        this.modalBerhasilIsOpen = true;
      } else {
        this.modalBerhasilIsOpen = false;
      }
    },
    // buka atau tutup modal gagal
    openCloseModalGagal(isOpen) {
      if (isOpen) {
        this.modalGagalIsOpen = true;
      } else {
        this.modalGagalIsOpen = false;
      }
    },

    // cek perubahan input untuk munculin input title
    inputChanged(event) {
      let title = event.target.previousSibling;
      if (event.target.value.length > 0) title.style.display = "block";
      else title.style.display = "none";
    },

    processFile(event) {
      this.pengajuanCuti.lampiran = event.target.files[0];
      let title = event.target.previousSibling;
      if (event.target.value.length > 0) title.style.display = "block";
      else title.style.display = "none";
    },

    // cek perubahan input tanggal akhir, value tidak dimasukan jika tanggal mulai belum diisi
    inputChangedAkhir(event) {
      // ketika tanggal mulai belum diisi
      if (!this.pengajuanCuti.tanggalMulai) {
        this.pengajuanCuti.tanggalAkhir = null;
        alert("Silahkan menginput tanggal mulai terlebih dahulu");
        return;
      }
      // ketika tanggal mulai sudah diisi
      else {
        let title = event.target.previousSibling;
        if (event.target.value.length > 0) title.style.display = "block";
        else title.style.display = "none";
      }
    },

    checkForm() {
      let valid = true;
      let pengajuanCuti = this.pengajuanCuti;

      if (!pengajuanCuti.tanggalMulai) {
        this.$refs["tanggal-mulai-form"].classList.add("failed-box-form");
        valid = false;
      }

      if (!pengajuanCuti.tanggalAkhir) {
        this.$refs["tanggal-akhir-form"].classList.add("failed-box-form");
        valid = false;
      }

      if (!pengajuanCuti.lampiran) {
        this.$refs["lampiran-form"].classList.add("failed-box-form");
        valid = false;
      }

       if (this.$refs["lampiran-input"].files[0].size >= 3500000) {
        this.$refs["lampiran-form"].classList.add("failed-box-form");
        valid = false;
      }

      if (!pengajuanCuti.keterangan) {
        this.$refs["keterangan-form"].classList.add("failed-box-form");
        valid = false;
      }
      return valid;
    },

    async ajukanCuti() {
      let check = this.checkForm();
      this.loader(true);
      if (check) {
        // jalankan api
        await soluhaApi.ajukanCuti(
          this.dateToEpoch(this.pengajuanCuti.tanggalMulai),
          this.dateToEpoch(this.pengajuanCuti.tanggalAkhir),
          this.pengajuanCuti.keterangan,
          this.pengajuanCuti.lampiran
        );
        this.openCloseModalBerhasil(true);
        // reset form
        this.pengajuanCuti.tanggalMulai = null;
        this.pengajuanCuti.tanggalAkhir = null;
        this.pengajuanCuti.keterangan = null;
        this.pengajuanCuti.lampiran = null;
      } else {
        this.openCloseModalGagal(true);
      }
      this.loader(false);
    },

    dateToEpoch(date) {
      let time = new Date(date);
      return time.getTime();
    },

    goToRiwayat() {
      this.$emit("changeComponent", "Riwayat");
    },

    loader(isLoading) {
      let textButton = this.$refs["button-text"];
      let spinner = this.$refs["spinner"];
      if (isLoading) {
        textButton.style.display = "none";
        spinner.style.display = "block";
        this.isProcessing = true;
      } else {
        textButton.style.display = "block";
        spinner.style.display = "none";
        this.isProcessing = false;
      }
    },
  },

  computed: {
    // tanggal minimal pengajuan cuti
    minDateMulai() {
      let today = new Date();
      let tomorrow_7 = new Date(today);
      tomorrow_7.setDate(tomorrow_7.getDate());
      tomorrow_7 = tomorrow_7.toISOString().split("T")[0];
      return tomorrow_7;
    },

    // tanggal minimal pengajuan akhir cuti (minimal sama dengan hari pengajuan)
    minDateAkhir() {
      let tanggalMulai = this.pengajuanCuti.tanggalMulai;
      let tomorrow_1 = new Date(tanggalMulai);
      tomorrow_1.setDate(tomorrow_1.getDate());
      tomorrow_1 = tomorrow_1.toISOString().split("T")[0];
      return tomorrow_1;
    },

    ...mapState(["listKeteranganCuti"]),
  },
};
</script>

<style scoped>
@import url("../../assets/css/karyawan/absensi.css");
</style>
